export const CLAIM_FORM = ({ breakdownOptions, breakdownSubOptions }) => {
  return [
    {
      name: 'warrantyCode',
      type: 'INPUT',
      placeholder: '',
      label: 'รหัสรับประกัน',
      disabled: true,
    },
    {
      name: 'warrantyId',
      type: 'HIDDEN',
    },

    {
      name: 'mobileBrandName',
      type: 'INPUT',
      placeholder: '',
      label: 'ยี่ห้อมือถือ',
      disabled: true,
    },
    {
      name: 'mobileModelName',
      type: 'INPUT',
      placeholder: '',
      label: 'รุ่นมือถือ',
      disabled: true,
    },
    {
      name: 'breakdownId',
      type: 'DROPDOWN',
      placeholder: 'เลือกอาการเสีย',
      label: 'อาการเสีย',
      properties: {
        options: breakdownOptions || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'breakdownSubId',
      type: 'DROPDOWN',
      placeholder: 'เลือกอาการเสียย่อย',
      label: 'อาการเสียย่อย',
      properties: {
        options: breakdownSubOptions || [],
      },
      rules: {
        required: true,
      },
    },
    // {
    //   name: 'detail',
    //   type: 'INPUT',
    //   placeholder: 'กรอกรายละเอียดเพิ่มเติม',
    //   label: 'รายละเอียดเพิ่มเติม',
    // },
  ];
};
export const FORM_SHOW_IMAGE_CLAIM = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/heic'];
  return [
    {
      name: 'claimImage',
      label: 'ภาพสินค้าเคลม (.png, .jpg, .jpeg, .heic) ',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาถ่ายภาพหรือเลือกภาพสินค้าที่ต้องการเคลม',
        },
      },
      accept: accept.join(','),
    },
  ];
};

export const FORM_ADDRESS = ({
  showOldAddress,
  watch,
  addressOptions,
  provinceOptions,
  districtOptions,
  subDistrictOptions,
}) => {
  const span = 12;

  return [
    {
      name: 'isCreateNewAddress',
      label: 'ที่อยู่จัดส่ง',
      type: 'RADIO',
      rules: {
        required: true,
      },
      span,
      defaultValue: 'true',
      disabled: true,
      properties: {
        options: [
          // { label: 'ที่อยู่เดิม', value: 'false' },
          { label: 'เพิ่มที่อยู่ใหม่', value: 'true' },
        ],
      },
    },

    ...(watch('isCreateNewAddress') !== 'true' && showOldAddress
      ? [
          {
            name: 'customerAddressId',
            label: 'เลือกที่อยู่',
            type: 'DROPDOWN',
            placeholder: 'กรุณาเลือก',
            properties: {
              options: addressOptions || [],
            },
            span: 24,
            style: {
              height: 'auto',
              maxHeight: '200px',
              width: '100%',
              overflowY: 'auto',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            },
          },
        ]
      : []),
    {
      name: 'zipcode',
      label: 'รหัสไปรษณีย์',
      type: 'INPUT_ZIPCODE',
      placeholder: 'กรุณากรอกรหัสไปรษณีย์',
      disabled: watch('isCreateNewAddress') !== 'true',
      rules: {
        required: true,
        pattern: /^[0-9]{5}$/,
      },
      maxLength: 5,
    },
    {
      name: 'provinceId',
      label: 'จังหวัด',
      type: 'DROPDOWN',
      placeholder: 'กรุณาเลือกจังหวัด',
      disabled: watch('isCreateNewAddress') !== 'true',
      properties: {
        options: provinceOptions || [],
      },

      rules: {
        required: true,
      },
    },
    {
      name: 'districtId',
      label: 'เขต/อำเภอ',
      type: 'DROPDOWN',
      placeholder: 'กรุณาเลือกเขต/อำเภอ',
      disabled: watch('isCreateNewAddress') !== 'true',
      properties: {
        options: districtOptions || [],
      },
      rules: {
        required: true,
      },
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    {
      name: 'subDistrictId',
      label: 'แขวง/ตำบล',
      type: 'DROPDOWN',
      placeholder: 'กรุณาเลือกแขวง/ตำบล',
      disabled: watch('isCreateNewAddress') !== 'true',
      properties: {
        options: subDistrictOptions || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'other',
      label: 'รายละเอียดเพิ่มเติม (บ้านเลขที่/ถนน/หมู่ที่/หมู่บ้าน)',
      type: 'INPUT_AREA',
      placeholder: 'กรอกรายละเอียดที่อยู่',
    },
  ];
};
export const FORM_PIC = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/heic'];
  return [
    {
      name: 'receiptImage',
      label: 'รูปภาพใบเสร็จ',
      type: 'UPLOAD_PIC',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาแนบรูปภาพใบเสร็จ',
        },
      },
      accept: accept.join(','),
      maxCount: 1,
    },
  ];
};
